import { Helmet } from 'react-helmet-async';
import React, { useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import HeroLayout from '@/components/shared/hero/HeroLayout';
import HeroTransparentCardLayout from '@/components/shared/hero/HeroTransparentCardLayout';
import ForgotPasswordSmsForm from '@/pages/forgot-password-sms/ForgotPasswordSmsForm';
import ForgotPasswordSmsChangeForm from '@/pages/forgot-password-sms/ForgotPasswordSmsChangeForm';
import ForgotPasswordSmsSuccess from '@/pages/forgot-password-sms/ForgotPasswordSmsSuccess';

enum ForgotPasswordSmsFlowStep {
  Forgot,
  Change,
  Success,
}

function ForgotPasswordSms() {
  const intl = useIntl();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [flowStep, setFlowStep] = useState<ForgotPasswordSmsFlowStep>(
    ForgotPasswordSmsFlowStep.Forgot,
  );
  const [mobile, setMobile] = useState<{ mobile: string; mobilePrefix: string } | undefined>(
    undefined,
  );

  const headingId = useMemo(() => {
    switch (flowStep) {
      case ForgotPasswordSmsFlowStep.Change:
        return 'reset.header';

      case ForgotPasswordSmsFlowStep.Success:
        return 'authentication.forgot-password-success.sms.header';

      default:
        return 'authentication.forgot-password.header';
    }
  }, [flowStep]);

  return (
    <>
      <Helmet>
        <title>LuckyDays - {intl.formatMessage({ id: 'forgot.title' })}</title>
      </Helmet>
      <HeroLayout fullHeight={true} isAuthenticated={isAuthenticated}>
        <HeroTransparentCardLayout
          heading={
            <FormattedMessage
              id={headingId}
              values={{
                span: str => <span className="text-blue-blue">{str}</span>,
              }}
            />
          }
        >
          {flowStep === ForgotPasswordSmsFlowStep.Forgot && (
            <ForgotPasswordSmsForm
              onSuccessCallback={mobile => {
                setMobile(mobile);
                setFlowStep(ForgotPasswordSmsFlowStep.Change);
              }}
            />
          )}
          {flowStep === ForgotPasswordSmsFlowStep.Change && !!mobile && (
            <ForgotPasswordSmsChangeForm
              mobile={mobile}
              onSuccessCallback={() => setFlowStep(ForgotPasswordSmsFlowStep.Success)}
            />
          )}
          {flowStep === ForgotPasswordSmsFlowStep.Success && <ForgotPasswordSmsSuccess />}
        </HeroTransparentCardLayout>
      </HeroLayout>
    </>
  );
}

export default ForgotPasswordSms;
